/**
 *
 * EventInfo
 *
 */

import React, { FunctionComponent } from 'react';
import { StyledEventInfo, StyledSplashWrapper } from './styledComponents';
import fbIcon from '../../assets/icons/fb.svg';
import twIcon from '../../assets/icons/tw.svg';
import calendarIcon from '../../assets/icons/calendar.svg';
import flagIcon from '../../assets/icons/flag.svg';
import usersIcon from '../../assets/icons/users.svg';
import refreshIcon from '../../assets/icons/refresh.svg';
import LiveNewsSidebarComponent from '../LiveNewsSidebar/LiveNewsSidebar.component';
import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../app/store';
import moment from 'moment';
import { useEventFeed } from '../../api/useEventFeed';
import { useQueryParams } from 'use-query-params';
import { AppQueryParamsConfigMap } from '../../app/constants';
import SplashScreenComponent from '../SplashScreen/SplashScreen.component';
import EmptyPageComponent from '../EmptyPage/EmptyPage.component';
import { APP_NAME_POSTFIX } from '../../constants';
import useAskForEventUpdates from '../../features/App/hooks/useAskForEventUpdates';
import infoIcon from '../../assets/icons/info.svg';

interface IProps {}
const connector = connect((state: RootState) => ({}), {});

type PropsFromRedux = ConnectedProps<typeof connector>;

const EventInfo: FunctionComponent<IProps & PropsFromRedux> = () => {
  const [query] = useQueryParams(AppQueryParamsConfigMap);
  const { data: activeEvent, isFetching } = useEventFeed({
    eventId: query.e,
  });

  const { data: lastTimeUpdatedTimestamp } = useAskForEventUpdates(query.e);

  if (!activeEvent && isFetching) {
    return (
      <StyledSplashWrapper>
        <SplashScreenComponent />
      </StyledSplashWrapper>
    );
  }

  if (!activeEvent && query.e) {
    return (
      <div className="d-flex align-items-center justify-content-center w-100">
        <EmptyPageComponent title="Event with this id doesn't exist" />
      </div>
    );
  }

  if (!activeEvent) {
    return null;
  }

  const urlToShare = `${window.location.origin}/feed?e=${activeEvent.eventId}`;

  if (!activeEvent.eventName) {
    return null;
  }
  return (
    <StyledEventInfo>
      <div className="logo">
        <img src={activeEvent.logoUrl} alt={activeEvent.eventName} />
      </div>
      <div>
        <div className="logo-title">{activeEvent.eventName}</div>

        <div className="social-links">
          <a
            href={`https://www.facebook.com/sharer.php?u=${urlToShare}&quote=${activeEvent.eventName} - ${APP_NAME_POSTFIX}`}
            className="link-social"
            target="_blank"
            rel="noreferrer"
          >
            <img src={fbIcon} alt="" />
          </a>
          <a
            href={`https://twitter.com/intent/tweet?url=${urlToShare}&text=${activeEvent.eventName} - ${APP_NAME_POSTFIX}`}
            className="link-social"
            target="_blank"
            rel="noreferrer"
          >
            <img src={twIcon} alt="" />
          </a>
        </div>
        <p className="txt-secondary loading">
          {isFetching ? 'Loading...' : ''}
        </p>
      </div>

      <div className="event-data-col">
        <div className="event-data-item">
          <div className="lbl mb-4">Event Date</div>
          <div className="d-flex align-items-center">
            <div className="icon">
              <img src={calendarIcon} alt="" />
            </div>
            <div className="event-data-txt">{activeEvent.eventDate}</div>
          </div>
        </div>
        <div className="event-data-item">
          <div className="lbl mb-4">Venue</div>
          <div className="d-flex align-items-center">
            <div className="icon">
              <img src={flagIcon} alt="" />
            </div>
            <div className="event-data-txt">{activeEvent.venueName}</div>
          </div>
        </div>
      </div>
      <div className="event-data-col">
        <div className="event-data-item">
          <div className="lbl mb-4">Total Entries</div>
          <div className="d-flex align-items-center">
            <div className="icon">
              <img src={usersIcon} alt="" />
            </div>
            <div className="event-data-txt">
              {activeEvent.eventClassList.reduce(
                (acc, curr) => acc + curr.numberOfEntries,
                0,
              )}
            </div>
          </div>
        </div>
        <div className="event-data-item">
          <div className="lbl mb-4">Last Time Updated</div>
          <div className="d-flex align-items-center">
            <div className="icon">
              <img src={refreshIcon} alt="" />
            </div>
            <div className="event-data-txt">
              {moment(lastTimeUpdatedTimestamp).format('DD MMM YYYY hh:mm A')}
            </div>
          </div>
        </div>
      </div>
      <div className="event-data-col">
        <div className="event-data-item">
          <div className="lbl mb-4">Status</div>
          <div className="d-flex align-items-center">
            <div className="icon">
              <img src={infoIcon} alt="" />
            </div>
            {activeEvent.status === 'Results Available' ? (
              <div className="event-data-txt txt-accent">Results Available</div>
            ) : (
              <div
                className={`event-data-txt ${
                  activeEvent.status === 'Cancelled' ||
                  activeEvent.status === 'Postponed'
                    ? 'red'
                    : ''
                }`}
              >
                {activeEvent.status}
              </div>
            )}
          </div>
        </div>
        <div className="event-data-item" />
      </div>
      <div className="mobile-live-news mt-40">
        <LiveNewsSidebarComponent expanded />
      </div>
    </StyledEventInfo>
  );
};

export default connector(EventInfo);
